import { ReactComponent as Logo } from "assets/Svgs/logo.svg";
import AuthBanner from "./AuthBanner";
import { Stack } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { useEffect, useState } from "react";
import { useBoundStore } from "store/store";
import i18n from "i18n/i18n";

interface LoginWrapperOptions {
  showLogo: boolean;
  children?: any; // children components under this wrapper
  showBanner?: string | null;
  bannerContent?: any;
}

function LoginWrapper(props: LoginWrapperOptions) {
  const { loginError,setLoginError } = useBoundStore();

  const [err, setError] = useState("");

  let lang = navigator?.language.split("-")[0]; // e.g "de" from de-DE

  function Alert(props: any) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  useEffect(() => {
    setError(loginError);
  }, [loginError]);

  return (
    <div className="login_wrapper">
      <div className="login_card bxShadow">
        <Stack sx={{ width: "100%" }} spacing={2}>
          {err && (
            <Alert
              severity="error"
              variant="outlined"
              sx={{ boxShadow: 10 }}
              onClick={() => setLoginError("")}
            >
              {err}
            </Alert>
          )}
        </Stack>
        {props.showLogo && (
          <div className="logo">
            <Logo />
          </div>
        )}
        {props.showBanner && (
          <AuthBanner
            icon={props.bannerContent.icon}
            title={props.bannerContent.title}
            description={props.bannerContent.description}
          />
        )}
        {props.children}
      </div>
      <div className="footerLinks">
        <div
          className="cp"
          onClick={() => {
            window.open("https://www.mesutronic.de/kontakt/");
          }}
        >
          {i18n(lang)?.footer_contact}
        </div>
        {/* <div>{i18n(lang)?.footer_data_protection}</div> */}
        <div
          className="cp"
          onClick={() => {
            window.open("https://www.mesutronic.de/impressum/");
          }}
        >
          {i18n(lang)?.footer_impressum}
        </div>
      </div>
    </div>
  );
}

export default LoginWrapper;
